"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (_ref) {
  var style = _ref.style,
      width = _ref.width,
      height = _ref.height;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon",
    viewBox: "0 0 1024 1024",
    style: customStyles,
    width: width,
    height: height
  }, _react2.default.createElement("path", {
    fill: "currentColor",
    d: "M949.76 146.944L877.056 74.24c-24.064-24.064-62.976-24.064-87.04 0L512 352.256 233.984 74.24c-24.064-24.064-62.976-24.064-87.04 0L74.24 146.944c-24.064 24.064-24.064 62.976 0 87.04L352.256 512 74.24 790.016c-24.064 24.064-24.064 62.976 0 87.04l72.704 72.704c24.064 24.064 62.976 24.064 87.04 0L512 671.744 790.016 949.76c24.064 24.064 62.976 24.064 87.04 0l72.704-72.704c24.064-24.064 24.064-62.976 0-87.04L671.744 512 949.76 233.984c24.064-24.064 24.064-62.976 0-87.04z"
  }));
};